import {Avatar, Card, CardActionArea, CardHeader, Divider, Grid, Typography, useTheme} from "@mui/material";
import SvgIconIXBT from "../util/SvgIconIXBT";
import SvgIconStopGame from "../util/SvgIconStopGame";
import SvgIconTumblr from "../util/SvgIconTumblr";
import SvgIconDonationAlerts from "../util/SvgIconDonationAlerts";
import SvgIconMemeAlerts from "../util/SvgIconMemeAlerts";
import SvgIconSponsr from "../util/SvgIconSponsr";
import SvgIconBoomstarter from "../util/SvgIconBoomstarter";
import React from "react";
import {useLocale} from "../locale/Locale";
import SvgIconVKDonut from "../util/SvgIconVKDonut";

function AppInactive() {

    const {localeText} = useLocale()

    const xs = 12
    const sm = 4
    const md = 3

    return (
        <>
            <Typography variant="h2" align="center">{localeText('inactiveTitle')}</Typography>
            <Typography align="center" mb={2}>{localeText('inactiveDescription')}</Typography>
            <Grid container spacing={2}>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.donationalerts.com/r/vittalucis"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconDonationAlerts/>
                                    </Avatar>
                                }
                                title="Donation Alerts"
                                subheader="@vittalucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://memealerts.com/isaev_space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconMemeAlerts/>
                                    </Avatar>
                                }
                                title="Meme Alerts"
                                subheader="@isaev_space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.tumblr.com/isaev-space"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconTumblr sx={{color: useTheme().palette.text.primary}}/>
                                    </Avatar>
                                }
                                title="Tumblr"
                                subheader="@isaev-space"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                {/*<Grid item xs={xs} sm={sm} md={md}>*/}
                {/*    <Card>*/}
                {/*        <CardActionArea*/}
                {/*            href="https://taplink.cc/isaevspace"*/}
                {/*            target="_blank"*/}
                {/*        >*/}
                {/*            <CardHeader*/}
                {/*                avatar={*/}
                {/*                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>*/}
                {/*                        <SvgIconTaplink/>*/}
                {/*                    </Avatar>*/}
                {/*                }*/}
                {/*                title="Taplink"*/}
                {/*                subheader="@isaevspace"*/}
                {/*            />*/}
                {/*        </CardActionArea>*/}
                {/*    </Card>*/}
                {/*</Grid>*/}
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://vk.com/donut/isaev_inc"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconVKDonut/>
                                    </Avatar>
                                }
                                title="VK Donut"
                                subheader="@isaev_inc"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://sponsr.ru/isaevspace"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconSponsr/>
                                    </Avatar>
                                }
                                title="Sponsr"
                                subheader="@isaevspace"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://boomstarter.ru/profile/isaevspace"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconBoomstarter/>
                                    </Avatar>
                                }
                                title="Boomstarter"
                                subheader="@isaevspace"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://stopgame.ru/user/Nanaki/blogs"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconStopGame/>
                                    </Avatar>
                                }
                                title="StopGame"
                                subheader="@Nanaki"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={xs} sm={sm} md={md}>
                    <Card>
                        <CardActionArea
                            href="https://www.ixbt.com/live/profile/350556/created/topics/"
                            target="_blank"
                        >
                            <CardHeader
                                avatar={
                                    <Avatar sx={{bgcolor: useTheme().palette.background.default}}>
                                        <SvgIconIXBT/>
                                    </Avatar>
                                }
                                title="iXBT"
                                subheader="@NanakiLucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppInactive
